module.exports = __webpack_public_path__ + "static/img/bg.19b3ad90.png";